function importAll(r) {
  r.keys().forEach(r);
}

// Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Icons
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-icons/font/bootstrap-icons.min.css";

// Other
import "aos/dist/aos.css";
import "aos/dist/aos.js";
import "glightbox/dist/css/glightbox.min.css";
import "glightbox/dist/js/glightbox.min.js";
importAll(require.context("isotope-layout/dist", true, /\.min.js$/));
import "swiper/css/bundle";

// Custom
import "./assets/css/main.css";
import "./assets/js/main.js";

// Assets
// Images
importAll(require.context("./assets/img/", true, /\.(png|avif)$/));
